import React from 'react';
import { Button } from '@mui/material';
import './Helper.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { getAxiosBackendClient } from './axiosBackendConfig';
import { confirmAlert } from 'react-confirm-alert';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';

export const dateTimeDiff = (dt, day, hour, min, sec, now) => {
  if (dt != null) {
    const date1 = new Date(dt);
    const date2 = new Date();

    const time1 = Math.floor(date1.getTime() / 1000);
    const time2 = Math.floor(date2.getTime() / 1000);

    const difference = Math.abs(time1 - time2);
    const daysDifference = Math.floor(difference / 60 / 60 / 24);
    const hoursDifference = Math.floor((difference % (60 * 60 * 24)) / (60 * 60));
    const minutesDifference = Math.floor((difference % (60 * 60)) / 60);
    const secondsDifference = difference % 60;

    const isExactMatch = time1 === time2;

    return {
      diff: isExactMatch
        ? now
        : (Math.abs(daysDifference) > 0 ? daysDifference + ' ' + day + ' ' : '') +
          (Math.abs(hoursDifference) > 0 ? hoursDifference + ' ' + hour + ' ' : '') +
          (Math.abs(minutesDifference) > 0 ? minutesDifference + ' ' + min + ' ' : '') +
          (Math.abs(secondsDifference) > 0 ? secondsDifference + ' ' + sec : ''),
      color: time2 - time1 <= 2 * 60 ? 'green' : 'red',
      diffMin: (time2 - time1) / 60,
      sign: time1 > time2 ? '+' : time1 < time2 ? '-' : '0',
    };
  }
  return {
    diff: null,
    color: null,
    diffMin: null,
    sign: null,
  };
};

export const warningAlert = (header, message) => {
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <div className='warning-alert-content'>
          <h1 className='warning-alert-header'>{header}</h1>
          {message.map((m, i) => (
            <p key={'warning-alert-message_' + (i + 1)} className='warning-alert-message'>
              {m}
            </p>
          ))}
          <Button onClick={onClose} variant='outlined' color='error'>
            OK
          </Button>
        </div>
      );
    },
  });
};

export const removeItem = async (url, id) => {
  return getAxiosBackendClient()(url + '?id=' + id, {
    method: 'delete',
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
    },
  })
    .then((res) => res.data)
    .catch((err) => console.log(err));
};

export const saveImages = async (url, data) => {
  return getAxiosBackendClient()
    .post(url, data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
      },
    })
    .then((res) => res)
    .catch((error) => error);
};

export const saveFormData = async (url, data) =>
  getAxiosBackendClient()
    .post(url, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
      },
    })
    .then((res) => res)
    .catch((err) => err);

const suppressSnackbarCustomConfig = {
  customConfig: { suppressSnackbar: true },
};

export const getRowDataWithPost = async (url, obj) => {
  return getAxiosBackendClient()
    .post(url, obj, {
      headers: {
        'Content-Type': 'application/json',
      },
      ...suppressSnackbarCustomConfig,
    })
    .then((res) => res)
    .catch((err) => console.log(err));
};

export const setResolvedAlerts = async (url, logIds) => {
  return getAxiosBackendClient()
    .post(
      url,
      { logIds: logIds },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
        },
        ...suppressSnackbarCustomConfig,
      },
    )
    .then((res) => (res.data ? res.data : []))
    .catch((err) => console.log(err));
};

export const getStopListTerminalSatuses = async (url, stopIds) => {
  return getAxiosBackendClient()
    .post(
      url,
      { stopIds: stopIds },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
        },
        ...suppressSnackbarCustomConfig,
      },
    )
    .then((res) => (res.data ? res.data : []))
    .catch((err) => console.log(err));
};

export const getRowData = async (url) => {
  let config = {
    method: 'get',
    url: url,
    maxBodyLength: Infinity,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
    },
  };
  return getAxiosBackendClient()(config)
    .then((res) => (res.data ? res.data : []))
    .catch((err) => console.log(err));
};

export const getRowDataErrorHandle = async (url) => {
  let config = {
    method: 'get',
    url: url,
    maxBodyLength: Infinity,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
    },
  };
  return getAxiosBackendClient()(config)
    .then((res) => res)
    .catch((err) => console.log(err));
};

export const JumpToTop = () => {
  return (
    <div id='jump-to-top-content' onClick={() => window.scrollTo(0, 0)}>
      <KeyboardDoubleArrowUpIcon />
    </div>
  );
};
